// Все дальнейшие методы связанные с компетенциями переносить сюда!!!

import Vue from 'vue'
import { router } from '@src/routes'

const isProd = process.env.NODE_ENV === 'production'

const SUCCESS = { success: true }
const ERROR = { success: false }

export default {
  namespaced: true,
  state: {
    linkFaq: null,
    optionsRequest: null,
    competencies: [],
    filter: null,
    availableCompetencies: [],
    currencies: [],
    legalInfo: null,
  },
  getters: {
    isLegalInfoSetted(state) {
      if (!state.legalInfo) return false
      return Object.values(state.legalInfo).some(el => el.value === 1)
    },
  },
  mutations: {
    setData(state, newData) {
      for (const key in newData) {
        state[key] = newData[key]
      }
    },
  },
  actions: {
    openErrorModal({ dispatch }, data) {
      let text = window.staticText.lk.lkErrorText
      if (data && data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }

      dispatch(
        'modal/modalType_errorOpen',
        {
          title: window.staticText.modal.errorTitle,
          text: text,
          class: '_small',
        },
        {
          root: true,
        }
      )
    },
    openSuccessModal({ dispatch }) {
      dispatch(
        'modal/modalType_successOpen',
        {
          title: window.staticText.lk.compSuccessTitle,
          text: window.staticText.lk.compSuccessText,
          class: '_small',
        },
        { root: true }
      )
    },
    async updateMyOrganisationData({ dispatch }, formData) {
      const method = isProd ? 'post' : 'get'
      const url = isProd ? 'lk/partner/setlegalinfo' : 'lk/updateMyOrganisationData.json'

      try {
        const { data } = await Vue.http[method](url, formData)
        if (!data.success) throw data
        dispatch('openSuccessModal')
        return SUCCESS
      } catch (data) {
        dispatch('openErrorModal')
        return ERROR
      }
    },
    async getCompetenciesPage({ commit }, params) {
      const url = isProd ? 'lk/competencies' : 'lk/competenciesPage.json'

      try {
        const { data } = await Vue.http.get(url, { params })
        commit('setData', data)
      } catch (error) {
        switch (error.status) {
          case 403:
            router.push({ name: 'E403' })
            break
          default:
            router.push({ name: 'E404' })
            break
        }
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/lk-competencies.js